import { render, staticRenderFns } from "./TheCookieBar.vue?vue&type=template&id=576816a6&scoped=true"
import script from "./TheCookieBar.vue?vue&type=script&lang=js"
export * from "./TheCookieBar.vue?vue&type=script&lang=js"
import style0 from "./TheCookieBar.vue?vue&type=style&index=0&id=576816a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576816a6",
  null
  
)

export default component.exports